"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationDiscounter = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
/**
 * `Discounter` patches discounts into configuration prices
 */
class ConfigurationDiscounter {
    static apply(configurationPrices, discounts, count = 1) {
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(discounts, 'ConfigurationDiscounter.apply: configurationPrices: '),
            echain_shared_validation_1.Validator.definedNotNull(discounts, 'ConfigurationDiscounter.apply: discounts: '),
        ]);
        const clonedConfigurationPrices = (0, echain_shared_ts_utils_1.clonePrimitive)(configurationPrices);
        this.applyMinItemsKonfektionierungBasePriceEK(clonedConfigurationPrices, discounts, count);
        return clonedConfigurationPrices;
    }
    static applyMinItemsKonfektionierungBasePriceEK(configurationPrices, discounts, count) {
        var _a;
        if (configurationPrices && configurationPrices.konfektionierungPriceEK != null && count) {
            let bestDiscount;
            discounts.forEach((discount) => {
                if (discount.Type === echain_shared_articles_1.DiscountType.KONFEKTIONIERUNG_BASE_PRICE_EK &&
                    discount.Rule.Value.Countries[configurationPrices.usedCountry] != null &&
                    discount.Rule.Value.Countries[configurationPrices.usedCountry][configurationPrices.usedCurrency] != null &&
                    discount.Criteria.Type === echain_shared_articles_1.DiscountCriteriaType.MIN_ITEMS &&
                    discount.Criteria.Value <= count &&
                    !(bestDiscount && bestDiscount.Criteria.Value > discount.Criteria.Value)) {
                    bestDiscount = discount;
                }
            });
            if (bestDiscount) {
                if (bestDiscount.Rule.Type === echain_shared_articles_1.DiscountRuleType.PERCENTAGE) {
                    // set discountedKonfektionierungPriceEK
                    configurationPrices.discountedKonfektionierungPriceEK =
                        configurationPrices.konfektionierungPriceEK *
                            (1 -
                                bestDiscount.Rule.Value.Countries[configurationPrices.usedCountry][configurationPrices.usedCurrency] /
                                    100);
                    // patch totalVerpackungKonfektionierungPriceEK
                    configurationPrices.totalVerpackungKonfektionierungPriceEK =
                        count *
                            (((_a = configurationPrices.verpackungPriceEK) !== null && _a !== void 0 ? _a : 0) + configurationPrices.discountedKonfektionierungPriceEK);
                }
            }
        }
        return ConfigurationDiscounter;
    }
}
exports.ConfigurationDiscounter = ConfigurationDiscounter;
//# sourceMappingURL=ConfigurationDiscounter.js.map